<div class="settings-header">
    <div class="settings-header-row">
        <div class="left">
            <div class="w-50 input-container">
                <ng-select 
                    bindLabel="name" 
                    name="name" 
                    id="orgId" 
                    [items]="companies"
                    [(ngModel)]="selectedCompany"
                    [addTag]="false" 
                    [hideSelected]="false" 
                    [multiple]="false"
                    [closeOnSelect]="true" 
                    notFoundText="{{ 'SETTINGS.NO_ITEM_FOUND' | translate }}"
                    placeholder="{{ 'SETTINGS.COMPANY' | translate }}"
                    (change)="onCompanySelect($event)">
                </ng-select>
            </div>
        </div>
        <div class="right">
            <button class="primary-button"  (click)="openPopupCompany(null)">
               {{'SETTINGS.NEW_COMPANY' | translate}}
            </button>
        </div>
    </div>
    <div class="parent-container">
        <div class="settings-list">
            <ng-container *ngFor="let company of filteredCompanies; let i = index">
                <div class="row-container" [ngClass]="{ 'detailled': expandedRowIndex === i }">
                    <div class="row" >
                        <div class="table-column name ">
                            <div class="text-muted">{{ 'SETTINGS.NAME' | translate }}</div>
                            <div>{{ company.name }}</div>
                        </div>
                        <div class="table-column name">
                            <div class="text-muted">{{ 'SETTINGS.ORGANISATION' | translate }}</div>
                            <div>{{ getOrganizationName(company.managingOrganizationId) }}</div>
                        </div>
                        <div class="table-column name">
                            <div class="text-muted">{{ 'SETTINGS.COUNTRY' | translate }}</div>
                            <div>{{ getCountryName(company.countryId) }}</div>
                        </div>
                        <div class="table-column name">
                            <div class="text-muted">{{ 'SETTINGS.USERS' | translate }}</div>
                            <div>{{ company.nbUsers }}</div>
                        </div>
                        <div class="table-column actions">
                            <div class="actions-wrapper d-flex align-items-center">
                                <button class="tertiary-button" (click)="onDelete(company.id)"
                                [disabled]="company.nbUsers > 0"
                                [ngClass]="{ 'disabled': company.nbUsers > 0 }" >
                                <svg-icon src="./icon/delete.svg"></svg-icon>
                                {{ 'SETTINGS.DELETE' | translate }}
                            </button>
                            <button class="secondary-button" (click)="openPopupCompany(company)" >
                                <svg-icon src="./icon/edit-pencil.svg"></svg-icon>
                                {{ 'SETTINGS.MODIFY' | translate }}
                            </button>
                            </div>
                                <button class="collapse-toggle ms-auto"
                                (click)="toggleRowDetails(i); $event.stopPropagation()">

                                <img [src]="expandedRowIndex === i ? './icon/arraw-up.svg' : './icon/arraw-down.svg'"
                                    class="arrow-icon" />

                                </button>
                        </div>
                    </div>
                    <div class="users-style p-4" *ngIf="expandedRowIndex === i">
                        <div class="text-muted">Users</div>
                        
                        <div class="user-list">
                            <span
                              class="user-item"
                              *ngFor="let user of company.userName"
                              (click)="onUserClick(user.id)">
                              {{ user.name }}
                            </span>
                          </div>
                          
                      </div>
                      
                </div>
            </ng-container>
        </div>
    </div>
</div>